export class NhanVien {
    MaNV: string;
    TenNV: string;
    en_TenNV?: string;
    TenDangNhap: string;
    MatKhau: string;
    TrangThai: number;
    MaCH: string;
    LoaiNV?: string= "Normal";
}



// WEBPACK FOOTER //
// ./src/app/models/employees.model.ts